import { render, staticRenderFns } from "./deleteConfirmationModal.vue?vue&type=template&id=a2162504&scoped=true&"
import script from "./deleteConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./deleteConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2162504",
  null
  
)

export default component.exports